import { Luggage, Work } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";



export const BaggageComponent = ({ baggage, checkin }: { baggage: string | null, checkin : boolean }) => {
    const tCommon = useTranslations('common');
    const tFlightDetails = useTranslations('srpFlightDetails');
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                textAlign : 'left',
                mb: 0.5
            }}
        >
            {checkin ? 
                <Work sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }} />
                :  
                <Luggage sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }} />
            }
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '10px' }}>
                { checkin ? 
                    tCommon('checkin') : tCommon('cabinBaggage')
                } :
            </Typography>
                    
            {baggage ? (
                    <Typography variant="caption" fontWeight="bold" sx={{ ml: 0.5, fontSize: '10px', color: 'black' }}>
                        {baggage}
                    </Typography>
                ) : (
                    <Typography variant="caption" fontWeight="bold" sx={{ ml: 0.5, fontSize: '10px', color: 'red' }}>
                        {tFlightDetails('baggageFailureNote')}
                    </Typography>
            )}
        </Box>
    )
}